import { Component, Input, inject } from '@angular/core';
import { customCard } from 'src/app/shared/model/customCard';
import { TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'app-climate-initiatives',
  templateUrl: './climate-initiatives.component.html',
  styleUrl: './climate-initiatives.component.scss',
  standalone: false,
})
export class ClimateInitiativesComponent {
  @Input() cardslist!: customCard[];

  private translocoService = inject(TranslocoService);

  cardsList: customCard[] = [
    {
      icon: '/assets/icons/blue-folder-bg.svg',
      title: this.translocoService.translate('ressources.infographics'),
      link: 'home/ressources',
    },
    {
      icon: '/assets/icons/blue-folder-bg.svg',
      title: this.translocoService.translate(
        'ressources.sustainableTravelBrochure',
      ),
      link: 'home/ressources',
    },
    {
      icon: '/assets/icons/blue-folder-bg.svg',
      title: this.translocoService.translate(
        'ressources.carbonFootprintAssessment',
      ),
      link: 'home/ressources',
    },
    {
      icon: '/assets/icons/blue-folder-bg.svg',
      title: this.translocoService.translate('ressources.reductionPlan'),
      link: 'home/ressources',
    },
    {
      icon: '/assets/icons/blue-folder-bg.svg',
      title: this.translocoService.translate('ressources.customCommunication'),
      link: 'home/ressources',
    },
  ];
}
